import React from 'react'
import { Button, Text, A } from '@rebrandly/styleguide'

import './DomainUpsellBanner.css'

const DomainUpsellBanner = () => (
  <div className='DomainUpsellBanner'>
    <div className='Container--wide'>
      <div className='DomainUpsellBanner__container'>
        <Text size='3x-large' className='m-b-24'> Branded domains for just $2/year </Text>
        <Text size='regular' className='m-b-24'> Register a new custom domain and start creating branded links. Increase click-through-rate up to 39%. </Text>
        <A href='https://www.rebrandly.com/newdomain' target='_blank' >
          <Button theme='primary' size='lg'><span className='font-bold'>Search domains</span></Button>
        </A>
      </div>
    </div>
  </div>
)

export default DomainUpsellBanner
